export default __webpack_public_path__ + "static/media/Scholar's Tunic of Twining Smoke.d0ccdd22.jpg";